// src/components/Footer.js
import React from "react";
import { Link } from "react-router-dom";
import "../App.css";
import logo from "../images/logo.png";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-inner">
        {/* Quick Links */}
        <div className="footer-column">
          <h4>Quick Links</h4>
          <ul>
            <li>
              <Link to="/">Home</Link>
            </li>
            <li>
              <Link to="/about">About</Link>
            </li>
            <li>
              <Link to="/services">Services</Link>
            </li>
            <li>
              <Link to="/recruitment">Recruitment</Link>
            </li>
            <li>
              <Link to="/contact">Contact</Link>
            </li>
          </ul>
        </div>

        {/* Contact Info */}
        <div className="footer-column">
          <h4>Contact Info</h4>
          <ul className="footer-contact-list">

            {/* PHONE – updated + clickable */}
            <li>
              <a
                href="tel:+447508667276"
                className="footer-contact-item"
                style={{ textDecoration: "none", color: "inherit" }}
              >
                <span className="footer-icon">📞</span>
                <span>+44 7508 667276</span>
              </a>
            </li>

            {/* EMAIL – updated + clickable */}
            <li>
              <a
                href="mailto:ndilsdailycare@gmail.com"
                className="footer-contact-item"
                style={{ textDecoration: "none", color: "inherit" }}
              >
                <span className="footer-icon">📧</span>
                <span>ndilsdailycare@gmail.com</span>
              </a>
            </li>

            {/* ADDRESS – unchanged */}
            <li>
              <span className="footer-icon">📍</span>
              <span>NP18 1LS</span>
            </li>
          </ul>
        </div>

        {/* Legal */}
        <div className="footer-column">
          <h4>Legal</h4>
          <ul>
            <li>
              <Link to="/terms">Terms of Use</Link>
            </li>
            <li>
              <Link to="/privacy">Privacy Policy</Link>
            </li>
            <li>
              <Link to="/license">License Agreement</Link>
            </li>
          </ul>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="footer-bottom">
        <div className="footer-brand">
          <img
            src={logo}
            alt="Ndils Daily Care Logo"
            className="footer-logo-img"
          />
          <div className="footer-brand-text">
            <p>Compassionate Care, Every Day</p>
            <p className="footer-year">NdilsDailyCare © 2025</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
